import * as React from 'react'
import { useEffect, useState } from 'react'
import { Button, Stack } from '@mui/material'
import { AddBox, Save } from '@mui/icons-material'
import { Box } from '@mui/system'
import NewScreenStepper from './NewScreenStepper'
import PageSection from '../../../Constants&Theme/PageSection'
import { stackGap } from '../../../Constants&Theme/Spacing'
import ScreenInfo from './ScreenInfo'
import { useScreenContext } from '../../../Contexts/Modules/HealthModule/SelectedScreenModule'
import CollectionDialog from './CollectionDialog/CollectionDialog'
import CollectionCard from './CollectionCard'
import {
  useStuartGet,
  useStuartMutatePost,
} from '../../../APIs/Hooks/PhpAPIHooks'
import { useNavigate, useParams } from 'react-router-dom'
import { tsScreenCollection } from '../../../Typescript/DB_Interface'

function CreateCollections({ clone = false }: { clone?: boolean }) {
  const { editable } = useScreenContext()
  const navigate = useNavigate()
  const [mode, setMode] = useState<'add' | 'edit'>('add')
  const { screen_id, clone_id } = useParams()
  const [open, setOpen] = useState<
    (Partial<tsScreenCollection> & { index: number }) | undefined
  >(undefined)
  const collectionsQuery = useStuartGet(
    ['/screen/getScreenCollections.php', `?ScreenID=${screen_id}`],
    !!screen_id && !clone_id,
  )
  const collectionsCloneQuery = useStuartGet(
    ['/screen/getScreenCollections.php', `?ScreenID=${clone_id}`],
    !!clone_id,
  )
  const [cloneCollects, setCloneCollects] = useState<
    Partial<tsScreenCollection>[]
  >([])
  useEffect(() => {
    if (collectionsCloneQuery.data?.Collections) {
      setCloneCollects(collectionsCloneQuery.data.Collections)
    }
  }, [collectionsCloneQuery.data])

  const { mutate: saveCollects } = useStuartMutatePost(
    '/screen/addCollections.php',
    {
      ScreenID: screen_id,
      Collections: cloneCollects,
    },
    () => {
      navigate('../../collections', { replace: true })
    },
  )

  return (
    <Box sx={{ width: 1, maxWidth: 'md' }}>
      <NewScreenStepper step={1}>
        <ScreenInfo />
        <PageSection
          title={'Collections'}
          rightDecorator={
            <Box sx={{ flex: 1, justifyContent: 'flex-end', display: 'flex' }}>
              <Button
                variant="outlined"
                color="primary"
                endIcon={<AddBox />}
                disabled={!editable}
                onClick={() =>
                  setOpen({
                    Rebill: 'Y',
                    index: cloneCollects.length,
                  })
                }
              >
                Add a Collection
              </Button>
            </Box>
          }
        >
          <Stack
            width={1}
            gap={stackGap.col}
          >
            {(clone ? cloneCollects : (
              (collectionsQuery.data?.Collections as any[]) ?? []
            )
            ).map((item, index) => (
              <CollectionCard
                index={index}
                key={index}
                collection={item}
                setCollections={setCloneCollects}
                readOnly={!clone}
                setOpen={setOpen}
                setMode={setMode}
              />
            ))}
            {clone && (
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => {
                    if (cloneCollects.length === 0) {
                      navigate('../../collections', { replace: true })
                    } else {
                      saveCollects()
                    }
                  }}
                  startIcon={<Save />}
                  disabled={!editable}
                >
                  Save collection changes to Database
                </Button>
              </Box>
            )}
          </Stack>
          <CollectionDialog
            open={open}
            setOpen={setOpen}
            setCloneCollects={setCloneCollects}
            mode={mode}
          />
        </PageSection>
      </NewScreenStepper>
    </Box>
  )
}

export default CreateCollections
